module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_staffing-55fb252ee985695b541589bb06131b05.svg";